import { formatNumberToShort } from '../../../../helpers'
import { sdgNames } from './helpers'

export const getOptions = currencySymbol => {
  return {
    maintainAspectRatio: false,
    responsive: true,
    scales: {
      x: {
        grid: {
          display: false
        },
        ticks: {
          color: '#000',
          font: {
            size: 14,
            weight: 600
          }
        }
      },
      y: {
        beginAtZero: true,
        grid: {
          color: '#E0E0E0',
          drawBorder: false
        },
        ticks: {
          color: '#666',
          font: {
            size: 12
          },
          callback: function (value) {
            return currencySymbol + formatNumberToShort(value)
          }
        }
      }
    },
    plugins: {
      legend: {
        display: false
      },
      tooltip: {
        callbacks: {
          title: tooltipItem => {
            // Extract SDG number from label (e.g., "SDG 3" -> 3)
            const label = tooltipItem[0].label
            const sdgNumber = parseInt(label.replace('SDG ', ''))
            const sdgName = sdgNames[sdgNumber]

            // Return full SDG name if available
            return sdgName ? `${label}: ${sdgName}` : label
          },
          label: tooltipItem => {
            return currencySymbol + formatNumberToShort(tooltipItem.raw)
          }
        }
      },
      datalabels: {
        display: false // Hide datalabels since we have icons inside bars
      }
    }
  }
}
